module.exports = __webpack_public_path__ + "img/file-circle-exclamation.429dc432.svg";